<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="msg-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title" :class="{'pay' : type != 1}"></h5>

                    <div class="reward-view" v-if="giftList.length">
                        <div class="reward-item" v-for="(item,index) in giftList" :key="index">
                            <div class="r-wrapper">
                                <div class="pic" v-tips="item.giftId">
                                    <game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item>
                                </div>
                            </div>                              
                        </div>
                    </div>

                    <div class="msg-view">
                        <p>{{ text }}</p>
                    </div>                    

                    <div class="u-ctrl" v-if="giftList.length <= 4">
                        <div class="u-btn ok" @click="closeModal"></div>
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style scoped>
.msg-modal{
    position: relative;
    width: 629px;
    height:379px;
    background-image: url(~@/assets/images/modal/bg-modal-comgra.png);
}

.title{
    width: 516px;
    height: 55px;
    margin: 20px auto 10px;
    background-image: url(~@/assets/images/modal/title-comgra.png);    
}

.msg-view{
    display: flex;
    justify-content: center;
    align-items: center;
}

.msg-view p{
    padding: 0 36px;
    line-height: 1.8;
    font-size: 22px;
    color: #47505a;
}

.msg-view b{
    color: #47505a;
}

.u-ctrl{
    position: absolute;
    left: 50%;
    bottom: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(-50%);
}

.u-ctrl .u-btn.ok{
    width: 239px;
    height: 84px;
    background-image: url(~@/assets/images/modal/btn-know.png);    
}


.reward-view{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 0 56px;
    margin: 20px 0 20px;
}

.reward-item{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    height: 70px;
    margin: 0 20px 10px;
    background-image: url(~@/assets/images/pc/bg-item.png);   
}

.r-wrapper{
    width: 69px;
    height: 69px;
}

.r-wrapper>.pic{
    width: 100%;
    height: 100%;
}
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            type : 1,
            giftList : [],
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/SuccessModal/successModal.vue